import type * as types from './types';


const initialState = {
    status: 'IDLE',
    calendly: `https://vc${process.env.REACT_APP_DEBUG ? '-dev' : ''}.ayomi.fr?utm_source=home-9`,
    contractor: `https://${process.env.REACT_APP_DEBUG ? 'dev-dashboard.ayomi.fr' : 'dashboard.ayomi.fr'}`,
    minAmount: "20000",
    amountRegistration: "1000",
};

type ConfigAction = {
    type: typeof types[keyof typeof types];
    payload?: Partial<types.ConfigState>;
};


export default function configReducer(state = initialState, action: ConfigAction) {
    const { type, payload } = action;
    switch (type) {
        case 'UPDATE_STATUS':
            return { ...state, status: payload };
        case 'FETCH_CONFIG_DATA':
            return { ...state, ...payload, status: 'SUCCEEDED' };
        default:
            return { ...state };
    }
}